import React from 'react'

function Support() {
  return (
    <div>
    <br/> <br/>
    <h1>thes is Support page</h1>
    </div>
  )
}

export default Support